import React, { useEffect, useState } from "react";
import { Typography, Grid, Box, TextField } from "@mui/material";
import { TextareaAutosize } from "@material-ui/core";

export default function PayslipEarnings({ handleInputChange, formData }) {

  return (
    <Grid container spacing={2} style={{ marginBottom: "30px" }}>
      <Grid item xs={12} md={6} sm={6} sx={{ m: "10px" }}>
        <Box className="typography-title">
          <Typography variant="h1" className="payslip-heading-h1">
            Earnings
          </Typography>
        </Box>
      </Grid>
      <Grid
        container
        spacing={3}
        className=""
        sx={{ display: "flex", justifyContent: "center", m: 2, mb: 2 }}
      >
        <Grid item xs={10} md={5} sm={5}>
          <TextField
            name="basic_pay"
            fullWidth
            onChange={handleInputChange}
            label="Basic Pay"
            type="number"
            value={formData.basic_pay}
            required
            //  value={}
          />
        </Grid>
        <Grid item xs={10} md={5} sm={5}>
          <TextField
            name="house_rent_allowance"
            fullWidth
            onChange={handleInputChange}
            label="House Rent Allowance(HRA)"
            value={formData.house_rent_allowance}
            required
            type="number"
          />
        </Grid>
        <Grid item xs={10} md={5} sm={5}>
          <TextField
            fullWidth
            onChange={handleInputChange}
            value={formData.special_allowance}
            name="special_allowance"
            label="Special Allowance(SA)"
            type="number"
            required
          />
        </Grid>
        <Grid item xs={10} md={5} sm={5}>
          <TextField
            name="transportaion_allowance"
            fullWidth
            onChange={handleInputChange}
            value={formData.transportaion_allowance}
            label="transportation Allowance(TA)"
            type="number"
            required
          />
        </Grid>
        <Grid item xs={10} md={5} sm={5}>
          <TextField
            name="mobile_tel_allowance"
            fullWidth
            onChange={handleInputChange}
            value={formData.mobile_tel_allowance}
            label="Mobile Tel Allowance(MA)"
            type="number"
            required
          />
        </Grid>

        <Grid item xs={10} md={5} sm={5}>
          <TextField
            name="city_compensatory_allowance"
            fullWidth
            onChange={handleInputChange}
            value={formData.city_compensatory_allowance}
            label="City Compensatory Allowance(CCA)"
            type="number"
            required
          />
        </Grid>
        <Grid item xs={10} md={5} sm={5}>
          <TextField
            name="food_allowance"
            fullWidth
            onChange={handleInputChange}
            value={formData.food_allowance}
            label="Food Allowance (FA)"
            type="number"
            required
          />
        </Grid>
        <Grid item xs={10} md={5} sm={5}>
          <TextField
            name="other_allowance"
            fullWidth
            onChange={handleInputChange}
            value={formData.other_allowance}
            label="Other Allowance (OA)"
            type="number"
            required
          />
        </Grid>
        <Grid item xs={10} md={5} sm={5}>
          <TextField
            name="over_time"
            fullWidth
            onChange={handleInputChange}
            value={formData.over_time}
            label="Over Time"
            type="number"
            required
          />
        </Grid>
        <Grid item xs={10} md={5} sm={5}>
          <TextField
            name="bonus"
            fullWidth
            onChange={handleInputChange}
            value={formData.bonus}
            label="Bonus"
            type="number"
            required
          />
        </Grid>
        <Grid item xs={10} md={5} sm={5}>
          <TextField
            name="reimbursement"
            fullWidth
            onChange={handleInputChange}
            value={formData.reimbursement}
            label="Reimbursement"
            type="number"
            required
          />
        </Grid>
        <Grid item xs={10} md={5} sm={5}>
          <TextField
            name="other_earnings"
            fullWidth
            onChange={handleInputChange}
            value={formData.other_earnings}
            label="Other Earnings"
            type="number"
            required
          />
        </Grid>
        <Grid item xs={10} md={5} sm={5}></Grid>
        <Grid item xs={12} md={5} sm={5}>
          <TextareaAutosize
            className="textarea"
            name="notes"
            onChange={handleInputChange}
            value={formData.notes}
            placeholder="Notes...."
            type="text"
            required
          />

        </Grid>
        <Grid item xs={10} md={5} sm={5}>
          <TextField
            name="total_earnings"
            fullWidth
            value={formData.total_earnings}
            label="Total Earnings"
            type="number"
            disabled
            required
          />
        </Grid>
        <Grid item xs={10} md={5} sm={5}></Grid>
      </Grid>
    </Grid>
  );
}
